import { FileStatus } from '../types'
import { ClipLoader, ClockLoader } from 'react-spinners'


export const DELETE_FILE = {
  header: 'Delete File',
  content: 'Are you sure to delete the file?',
}

export const isUnhealthyFile = (status: string) =>
  status === FileStatus.FAILED ||
  status === FileStatus.INVALID ||
  status === FileStatus.MALICIOUS

export const renderIndicator = (fileStatus: string) => {
  if (fileStatus === FileStatus.SUCCEEDED)
    return (
      <div className="w-4 h-4 bg-green-200 rounded-full border-2 border-green-600 mr-2"></div>
    )
  else if (isUnhealthyFile(fileStatus))
    return (
      <div className="w-4 h-4  border-red-600 border-2 rounded-full mr-2"></div>
    )
  else if (fileStatus === FileStatus.UNCACHED) {
    return (
      <div className="mr-2">
        <ClockLoader color="#FBBF24" size={14} />
      </div>
    )
  } else
    return (
      <div className="mr-2">
        <ClipLoader color="#FBBF24" size={14} />
      </div>
    )
}

export const renderUnhealthyFileBadge = (status: string) => {
  switch (status) {
    case FileStatus.FAILED:
      return 'Failed'
    case FileStatus.INVALID:
      return 'Invalid'
    case FileStatus.MALICIOUS:
      return 'Malicious'
    default:
      return 'Something wrong'
  }
}
